module.exports = __webpack_public_path__ + "img/proapp-1.d9e07b79.webp";